import React, { Component } from "react";
import { Switch, Route, withRouter, Redirect } from "react-router-dom";
import SignIn from "./signIn";
import SignUp from "./components/signUp";
import Account from "./components/account";
import NotFound from "./containers/NotFound";
import AuthenticatedRoute from "./containers/AuthenticatedRoute";
import UnauthenticatedRoute from "./containers/UnauthenticatedRoute";
import ForgotPassword from "./components/forgotPassword";
import ContactSkyline from "./components/contactSkyline";
import Pricing from "./components/pricing";
import ResetPassword from "./components/resetPassword";
import ChangePassword from "./components/changePassword";
import PurchaseSucceeded from "./components/succefullyPurchased";
import InternalServerError from "./containers/InternalServerError";
import ContactUs from "./components/contactUs";
import AtlasUs from "./components/atlasUs";
import GettingStarted from "./components/gettingStarted";
import LosAngeles from "./components/losAngeles";
import GettingStartedProducts from "./components/gettingStartedProducts";
import GettingStartedUploads from "./components/gettingStartedUploads";
import UAVPricing from "./components/UAVPackage/pricing";
import UserPrivacyPreferences from "./components/updateUserPreferences";
import DeleteAccount from "./components/deleteAccount";
import Unsubscribe from "./components/unsubscribe";
import NewPMProject from "./components/PMAutomation/newPMProject";

function Menu(props) {
  //const isLoggedIn = props.isLoggedIn;
  return <Redirect to="/account" props={props} />;
}

class MainCore extends Component {
  state = {};

  constructor(props) {
    super(props);
  }

  render() {
    const childProps = {
      isLoggedIn: (this.props.isSubLoginType) ? false : this.props.isLoggedIn,
      userName: this.props.email,
      firstName: this.props.firstName,
      lastName: this.props.lastName,
      customerId: this.props.customerId,
      userHasAuthenticated: this.props.userHasAuthenticated,
      handleServerError: this.props.handleServerError,
      handleUpdates: this.props.handleUpdates,
      isSubLoginType: this.props.isSubLoginType,
      customerLogoUrl: this.props.customerLogoUrl,
      sgsUrl: this.props.sgsUrl
    };
    return (
      <Switch>
        <Route exact path="/" component={Menu} props={childProps} />
        <UnauthenticatedRoute
          exact
          path="/signIn"
          component={SignIn}
          props={childProps}
        />
        <AuthenticatedRoute
          exact
          path="/account/changePassword"
          component={ChangePassword}
          props={childProps}
        />
        <Route
          exact
          path="/account/unsubscribe"
          component={Unsubscribe}
          props={childProps}
        />
        <AuthenticatedRoute
          exact
          path="/account/privacy"
          component={UserPrivacyPreferences}
          props={childProps}
        />
        <AuthenticatedRoute
          exact
          path="/account/deleteAccount"
          component={DeleteAccount}
          props={childProps}
        />
        <AuthenticatedRoute
          exact
          path="/account/:packageId?/:productName?"
          component={Account}
          props={childProps}
        />
        <AuthenticatedRoute
          exact
          path="/PMProjects/newPMProject"
          component={NewPMProject}
          props={childProps}
        />
        <Route
          exact
          path="/atlasUs/pricing"
          render={() => <Pricing props={this.props} />}
        />
        {/* <Route
          exact
          path="/overview"
          render={() => <AtlasUs props={this.props} />}
        /> */}
        <Route
          exact
          path="/atlasUs/Overview"
          render={() => <AtlasUs props={this.props} />}
        />
        <Route
          exact
          path="/atlasUs/LosAngeles"
          render={() => <LosAngeles props={this.props} />}
        />
        <Route
          exact
          path="/gettingStarted"
          render={() => <GettingStarted props={childProps} />}
        />
        <Route
          exact
          path="/GettingStartedProducts"
          render={() => <GettingStartedProducts props={childProps} />}
        />
        <Route
          exact
          path="/GettingStartedUploads"
          render={() => <GettingStartedUploads props={childProps} />}
        />
        <Route
          exact
          path="/forgotPassword"
          component={ForgotPassword}
          props={childProps}
        />
        <Route
          exact
          path="/PurchaseSucceeded"
          render={() => <PurchaseSucceeded props={childProps} />}
        />
        {!this.props.isSubLoginType ?
          <Route
            exact
            path="/resetPassword"
            component={ResetPassword}
            props={childProps}
          />
          : null
        }
        <Route
          exact
          path="/contactUs"
          render={() => <ContactUs props={childProps} />}
        />
        <Route
          exact
          path="/UAVPackages/pricing"
          render={() => <UAVPricing props={childProps} />}
        />
        <Route
          exact
          component={InternalServerError}
          path="/internalServerError"
          props={childProps}
        />
        <Route
          exact
          path="/contactSkyline"
          render={() => <ContactSkyline props={childProps} />}        
        />
        <Route exact component={NotFound} props={childProps} />
      </Switch>
    );
    //<Menu isLoggedIn={this.props.isLoggedIn} />
  }
}

export default withRouter(MainCore);
